'use client';

import * as a from "react";
import p from "../lib/IconBase.es.js";
import a$1 from "../defs/CheckCircle.es.js";
const c = a.forwardRef((o, r) => /* @__PURE__ */ a.createElement(p, { ref: r, ...o, weights: a$1 }));
c.displayName = "CheckCircleIcon";
const s = c;
export {
  s as CheckCircle,
  c as CheckCircleIcon
};
